import React, { useEffect, useState } from 'react';
import { Scale, ShoppingBag, CreditCard, Truck, RotateCcw, AlertTriangle, FileText, Users, ShieldCheck, Gavel, Copyright, HelpCircle, ChevronRight, Check, ArrowRight, Mail, Lock, Globe, Ban, FileWarning } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
export function TermsPage() {
  const [activeSection, setActiveSection] = useState('general');
  // Handle scroll spy
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section[id]');
      let current = '';
      sections.forEach(section => {
        const sectionTop = (section as HTMLElement).offsetTop;
        if (window.scrollY >= sectionTop - 200) {
          current = section.getAttribute('id') || '';
        }
      });
      if (current) setActiveSection(current);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const sections = [{
    id: 'general',
    title: '1. Condiciones Generales',
    icon: Scale,
    content: <div className="space-y-4" data-id="element-6952">
          <p data-id="element-6953">
            Las presentes Condiciones Generales de Uso y de la Contratación (en
            adelante, "las Condiciones") rigen el acceso y la utilización del
            sitio web www.petiora.co (en adelante, "el Sitio Web"), titularidad
            de PETIORA S.L., así como la contratación de productos y servicios a
            través del mismo.
          </p>
          <div className="bg-amber-50 border border-amber-100 rounded-xl p-6 text-sm text-amber-900 flex gap-4" data-id="element-6954">
            <AlertTriangle className="w-5 h-5 flex-shrink-0 text-amber-600" data-id="element-6955" />
            <div data-id="element-6956">
              <strong data-id="element-6957">Aceptación Expresa:</strong> El acceso, navegación y uso
              del Sitio Web atribuye la condición de Usuario e implica la
              aceptación expresa y sin reservas de todos los términos incluidos
              en estas Condiciones Generales, teniendo la misma validez y
              eficacia que cualquier contrato celebrado por escrito y firmado.
            </div>
          </div>
          <p data-id="element-6958">
            Petiora se reserva el derecho de modificar, en cualquier momento y
            sin previo aviso, la presentación y configuración del Sitio Web, así
            como las presentes Condiciones Generales. Los Usuarios siempre
            dispondrán de estas Condiciones en un sitio visible, libremente
            accesible para cuantas consultas quiera realizar.
          </p>
        </div>
  }, {
    id: 'registro',
    title: '2. Registro y Seguridad',
    icon: Users,
    content: <div className="space-y-6" data-id="element-6959">
          <p data-id="element-6960">
            Para realizar pedidos en el Sitio Web, el Usuario puede optar por
            registrarse o realizar la compra como invitado. En ambos casos, el
            Usuario garantiza que los datos personales facilitados son veraces y
            exactos, y se compromete a notificar cualquier cambio o modificación
            de los mismos.
          </p>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-6961">
            {['Proporcionar datos veraces, exactos y completos', 'Mantener actualizada la información de la cuenta', 'Custodiar diligentemente la contraseña de acceso', 'No compartir las credenciales con terceros', 'Notificar inmediatamente cualquier acceso no autorizado', 'Ser mayor de edad legal (18 años) y tener capacidad para contratar'].map((item, idx) => <div key={idx} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100 transition-colors hover:border-primary-200" data-id="element-6962">
                <Check className="w-4 h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-6963" />
                <span className="text-sm text-gray-700 leading-snug" data-id="element-6964">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="bg-red-50 border border-red-100 rounded-xl p-4 flex gap-3" data-id="element-6965">
            <Ban className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-6966" />
            <p className="text-sm text-red-800" data-id="element-6967">
              Petiora se reserva el derecho de cancelar, suspender o inhabilitar
              cuentas que incumplan estas normas, realicen un uso fraudulento
              del servicio o atenten contra la seguridad del Sitio Web, sin
              derecho a indemnización alguna.
            </p>
          </div>
        </div>
  }, {
    id: 'productos',
    title: '3. Información de Productos',
    icon: ShoppingBag,
    content: <div className="space-y-4" data-id="element-6968">
          <p data-id="element-6969">
            Petiora pone el máximo cuidado en la presentación y descripción de
            los productos. Sin embargo, las fotografías y representaciones
            gráficas o iconográficas de todo tipo relativas a los productos
            tienen efectos meramente orientativos.
          </p>
          <ul className="list-disc pl-5 space-y-3 text-gray-600 marker:text-primary-500" data-id="element-6970">
            <li data-id="element-6971">
              <strong data-id="element-6972">Disponibilidad:</strong> Todos los pedidos están sujetos a
              la disponibilidad de los productos. Si se produjeran incidencias
              en cuanto a su suministro o no quedaran artículos en stock, se
              informará inmediatamente al Usuario y se reembolsará cualquier
              cantidad que hubiera podido abonar.
            </li>
            <li data-id="element-6973">
              <strong data-id="element-6974">Precios:</strong> Los precios mostrados incluyen el
              Impuesto sobre el Valor Añadido (IVA) vigente en España. No
              incluyen los gastos de envío, que se añadirán al importe total
              debido.
            </li>
            <li data-id="element-6975">
              <strong data-id="element-6976">Modificaciones:</strong> Nos reservamos el derecho de
              retirar cualquier producto del Sitio Web en cualquier momento y de
              modificar cualquier material o contenido del mismo.
            </li>
          </ul>
        </div>
  }, {
    id: 'pagos',
    title: '4. Precios y Pagos',
    icon: CreditCard,
    content: <div className="space-y-6" data-id="element-6977">
          <p data-id="element-6978">
            El Usuario se compromete a pagar en el momento que realiza el
            pedido. El ticket o comprobante de compra que corresponde al pedido
            de compra estará disponible y se podrá visualizar en la sección "Mi
            Cuenta".
          </p>

          <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm" data-id="element-6979">
            <h4 className="font-bold text-charcoal-800 mb-4 text-sm uppercase tracking-wider flex items-center gap-2" data-id="element-6980">
              <ShieldCheck className="w-4 h-4 text-emerald-500" data-id="element-6981" />
              Pasarela de Pago Segura
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-4" data-id="element-6982">
              {['Visa', 'Mastercard', 'PayPal', 'Apple Pay'].map(method => <div key={method} className="flex flex-col items-center justify-center p-4 bg-gray-50 rounded-xl border border-gray-100 hover:bg-gray-100 transition-colors" data-id="element-6983">
                  <CreditCard className="w-6 h-6 text-gray-400 mb-2" data-id="element-6984" />
                  <span className="text-xs font-bold text-gray-600" data-id="element-6985">
                    {method}
                  </span>
                </div>)}
            </div>
            <p className="text-xs text-gray-500 leading-relaxed" data-id="element-6986">
              Utilizamos sistemas de pago seguro de entidades financieras de
              primera línea en comercio electrónico. Los datos de pago son
              encriptados mediante protocolo SSL (Secure Socket Layer) de 256
              bits. Petiora no almacena datos bancarios confidenciales.
            </p>
          </div>
        </div>
  }, {
    id: 'envios',
    title: '5. Envíos y Entregas',
    icon: Truck,
    content: <div className="space-y-4" data-id="element-6987">
          <p data-id="element-6988">
            Petiora se compromete a entregar el producto en perfecto estado en
            la dirección que el Usuario señale en el formulario de pedido. Con
            el fin de optimizar la entrega, agradecemos al Usuario que indique
            una dirección en la cual el pedido pueda ser entregado dentro del
            horario laboral habitual.
          </p>
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-6989">
            <div className="p-5 bg-gray-50 rounded-xl border border-gray-100" data-id="element-6990">
              <h5 className="font-bold text-charcoal-800 mb-2 flex items-center gap-2" data-id="element-6991">
                <Globe className="w-4 h-4 text-primary-600" data-id="element-6992" />
                Península
              </h5>
              <p className="text-sm text-gray-600 mb-2" data-id="element-6993">
                24-48 horas laborables
              </p>
              <p className="text-xs text-gray-400" data-id="element-6994">
                Pedidos antes de las 14:00h
              </p>
            </div>
            <div className="p-5 bg-gray-50 rounded-xl border border-gray-100" data-id="element-6995">
              <h5 className="font-bold text-charcoal-800 mb-2 flex items-center gap-2" data-id="element-6996">
                <Globe className="w-4 h-4 text-primary-600" data-id="element-6997" />
                Baleares
              </h5>
              <p className="text-sm text-gray-600 mb-2" data-id="element-6998">
                48-72 horas laborables
              </p>
              <p className="text-xs text-gray-400" data-id="element-6999">
                Sujeto a condiciones marítimas
              </p>
            </div>
          </div>
          <p className="text-sm text-gray-500 italic mt-2" data-id="element-7000">
            Petiora no será responsable por los errores causados en la entrega
            cuando la dirección de entrega introducida por el Usuario en el
            formulario de pedido no se ajuste a la realidad o haya sido omitida.
          </p>
        </div>
  }, {
    id: 'devoluciones',
    title: '6. Devoluciones y Desistimiento',
    icon: RotateCcw,
    content: <div className="space-y-6" data-id="element-7001">
          <p data-id="element-7002">
            De conformidad con la normativa vigente, el Usuario dispone de un
            plazo de 30 días naturales desde la recepción del producto para
            ejercer su derecho de desistimiento sin necesidad de justificación.
          </p>

          <div className="relative pl-8 space-y-8 before:absolute before:left-3 before:top-2 before:bottom-2 before:w-0.5 before:bg-gray-200" data-id="element-7003">
            {[{
          title: 'Comunicación',
          desc: 'El usuario debe comunicar su intención de devolver el producto a través de su cuenta o contactando con atención al cliente.'
        }, {
          title: 'Estado del Producto',
          desc: 'El producto debe estar en el mismo estado en que se entregó y deberá conservar su embalaje y etiquetado original.'
        }, {
          title: 'Reembolso',
          desc: 'La devolución del importe se realizará en el mismo medio de pago utilizado en un plazo máximo de 14 días naturales desde la recepción.'
        }].map((step, idx) => <div key={idx} className="relative" data-id="element-7004">
                <div className="absolute -left-8 w-6 h-6 rounded-full bg-primary-100 border-2 border-white flex items-center justify-center text-xs font-bold text-primary-700 shadow-sm" data-id="element-7005">
                  {idx + 1}
                </div>
                <h5 className="font-bold text-charcoal-800" data-id="element-7006">{step.title}</h5>
                <p className="text-sm text-gray-600" data-id="element-7007">{step.desc}</p>
              </div>)}
          </div>

          <div className="bg-gray-50 p-5 rounded-xl border border-gray-100" data-id="element-7008">
            <h5 className="font-bold text-charcoal-800 mb-3 text-sm flex items-center gap-2" data-id="element-7009">
              <FileWarning className="w-4 h-4 text-amber-500" data-id="element-7010" />
              Excepciones al derecho de desistimiento:
            </h5>
            <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600" data-id="element-7011">
              <li data-id="element-7012">
                Bienes precintados que no sean aptos para ser devueltos por
                razones de protección de la salud o higiene y que hayan sido
                desprecintados tras la entrega.
              </li>
              <li data-id="element-7013">
                Bienes que puedan deteriorarse o caducar con rapidez (alimentos
                frescos o con caducidad corta).
              </li>
              <li data-id="element-7014">
                Bienes confeccionados conforme a las especificaciones del
                consumidor o claramente personalizados.
              </li>
            </ul>
          </div>
        </div>
  }, {
    id: 'propiedad',
    title: '7. Propiedad Intelectual e Industrial',
    icon: Copyright,
    content: <div className="space-y-4" data-id="element-7015">
          <p data-id="element-7016">
            Todos los contenidos del Sitio Web, entendiendo por estos a título
            meramente enunciativo, los textos, fotografías, gráficos, imágenes,
            iconos, tecnología, software, links y demás contenidos audiovisuales
            o sonoros, así como su diseño gráfico y códigos fuente (en adelante,
            los "Contenidos"), son propiedad intelectual de Petiora o de
            terceros, sin que puedan entenderse cedidos al Usuario ninguno de
            los derechos de explotación reconocidos por la normativa vigente
            sobre propiedad intelectual sobre los mismos.
          </p>
          <p data-id="element-7017">
            Las marcas, nombres comerciales o signos distintivos son titularidad
            de Petiora o terceros, sin que pueda entenderse que el acceso al
            Sitio Web atribuya ningún derecho sobre las citadas marcas, nombres
            comerciales y/o signos distintivos.
          </p>
          <div className="p-4 bg-primary-50 rounded-xl border border-primary-100 text-primary-900 text-sm font-medium" data-id="element-7018">
            Queda expresamente prohibida la reproducción, transformación,
            distribución, comunicación pública, puesta a disposición,
            extracción, reutilización, reenvío o la utilización de cualquier
            naturaleza, por cualquier medio o procedimiento, de cualquiera de
            ellos, salvo en los casos en que esté legalmente permitido o sea
            autorizado por el titular de los correspondientes derechos.
          </div>
        </div>
  }, {
    id: 'responsabilidad',
    title: '8. Limitación de Responsabilidad',
    icon: ShieldCheck,
    content: <div className="space-y-4" data-id="element-7019">
          <p data-id="element-7020">
            Petiora no garantiza la disponibilidad continua y permanente de los
            servicios, quedando de este modo exonerado de cualquier
            responsabilidad por posibles daños y perjuicios causados como
            consecuencia de la falta de disponibilidad del servicio por motivos
            de fuerza mayor o errores en las redes telemáticas de transferencia
            de datos, ajenos a su voluntad.
          </p>
          <p data-id="element-7021">
            Petiora no se hace responsable del contenido de los enlaces a otras
            páginas web que no sean titularidad suya y que, por tanto, no pueden
            ser controladas por ésta.
          </p>
          <p data-id="element-7022">
            El Usuario es el único responsable de las infracciones en las que
            pueda incurrir o de los perjuicios que pueda causar por la
            utilización del Sitio Web, quedando Petiora, sus socios, empresas
            del grupo, colaboradores, empleados y representantes, exonerados de
            cualquier clase de responsabilidad que se pudiera derivar por las
            acciones del Usuario.
          </p>
        </div>
  }, {
    id: 'proteccion',
    title: '9. Protección de Datos',
    icon: Lock,
    content: <div className="space-y-4" data-id="element-7023">
          <p data-id="element-7024">
            De conformidad con lo dispuesto en el Reglamento (UE) 2016/679 del
            Parlamento Europeo y del Consejo (RGPD) y la Ley Orgánica 3/2018 de
            Protección de Datos Personales y garantía de los derechos digitales,
            le informamos que los datos personales facilitados serán tratados
            por Petiora S.L.
          </p>
          <p data-id="element-7025">
            Para más información sobre el tratamiento de sus datos personales,
            consulte nuestra{' '}
            <Link to="/privacidad" className="text-primary-600 font-bold hover:underline" data-id="element-7026">
              Política de Privacidad
            </Link>{' '}
            y nuestra{' '}
            <Link to="/cookies" className="text-primary-600 font-bold hover:underline" data-id="element-7027">
              Política de Cookies
            </Link>
            .
          </p>
        </div>
  }, {
    id: 'ley',
    title: '10. Ley Aplicable y Jurisdicción',
    icon: Gavel,
    content: <div className="space-y-4" data-id="element-7028">
          <p data-id="element-7029">
            Las presentes Condiciones Generales se rigen por la legislación
            española. Las partes se someten, a su elección, para la resolución
            de los conflictos y con renuncia a cualquier otro fuero, a los
            juzgados y tribunales del domicilio del usuario.
          </p>
          <p data-id="element-7030">
            Asimismo, como entidad adherida a Confianza Online y en los términos
            de su Código Ético, en caso de controversias relativas a la
            contratación y publicidad online, protección de datos y protección
            de menores, el usuario podrá acudir al sistema de resolución
            extrajudicial de controversias de Confianza Online
            (www.confianzaonline.es).
          </p>
          <div className="mt-4 p-4 bg-gray-50 rounded-xl border border-gray-100" data-id="element-7031">
            <p className="text-sm text-gray-600" data-id="element-7032">
              La Comisión Europea facilita también una plataforma de resolución
              de litigios en línea, disponible en el siguiente enlace:{' '}
              <a href="http://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline" data-id="element-7033">
                http://ec.europa.eu/consumers/odr/
              </a>
            </p>
          </div>
        </div>
  }, {
    id: 'contacto',
    title: '11. Contacto',
    icon: Mail,
    content: <div className="space-y-4" data-id="element-7034">
          <p data-id="element-7035">
            Para cualquier duda, sugerencia, consulta o reclamación sobre el
            Sitio Web, puede dirigirse al Servicio de Atención al Cliente, por
            cualquiera de los siguientes medios:
          </p>
          <div className="grid sm:grid-cols-2 gap-4 mt-4" data-id="element-7036">
            <div className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm flex items-center gap-3" data-id="element-7037">
              <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center text-primary-600" data-id="element-7038">
                <Mail className="w-5 h-5" data-id="element-7039" />
              </div>
              <div data-id="element-7040">
                <div className="text-xs text-gray-500 font-bold uppercase" data-id="element-7041">
                  Email
                </div>
                <a href="mailto:legal@petiora.com" className="text-charcoal-800 font-medium hover:text-primary-600" data-id="element-7042">
                  legal@petiora.co
                </a>
              </div>
            </div>
            <div className="p-4 bg-white rounded-xl border border-gray-200 shadow-sm flex items-center gap-3" data-id="element-7043">
              <div className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center text-primary-600" data-id="element-7044">
                <FileText className="w-5 h-5" data-id="element-7045" />
              </div>
              <div data-id="element-7046">
                <div className="text-xs text-gray-500 font-bold uppercase" data-id="element-7047">
                  Dirección Postal
                </div>
                <div className="text-charcoal-800 font-medium text-sm" data-id="element-7048">
                  Calle Verde 123, 28001 Madrid
                </div>
              </div>
            </div>
          </div>
        </div>
  }];
  const scrollToSection = (id: string) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      const offset = 120; // Header height + padding
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <main className="min-h-screen bg-[#FAF7F2] pt-24 sm:pt-32 pb-20 font-sans" data-id="element-7049">
      <div className="container-custom" data-id="element-7050">
        {/* Header */}
        <div className="text-center mb-16 max-w-4xl mx-auto" data-id="element-7051">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-gray-100 text-primary-700 text-sm font-bold mb-6" data-id="element-7052">
            <FileText className="w-4 h-4" data-id="element-7053" />
            Documento Legal
          </motion.div>
          <h1 className="text-4xl md:text-6xl font-bold text-charcoal-800 mb-6 font-serif tracking-tight" data-id="element-7054">
            Términos y Condiciones
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-7055">
            Las reglas del juego claras para una relación de confianza. Por
            favor, lee detenidamente este documento antes de utilizar nuestros
            servicios.
          </p>
          <div className="mt-6 text-sm text-gray-500 font-medium" data-id="element-7056">
            Última actualización: Enero 2024
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-start" data-id="element-7057">
          {/* Sidebar Navigation (Desktop) */}
          <div className="hidden lg:block w-80 sticky top-32 flex-shrink-0" data-id="element-7058">
            <div className="bg-white rounded-3xl shadow-soft border border-gray-100 p-6 overflow-hidden" data-id="element-7059">
              <h3 className="font-bold text-charcoal-800 mb-6 px-2 text-lg font-serif" data-id="element-7060">
                Índice de Contenidos
              </h3>
              <nav className="space-y-1 max-h-[calc(100vh-300px)] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-gray-200" data-id="element-7061">
                {sections.map(section => <button key={section.id} onClick={() => scrollToSection(section.id)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 text-left group ${activeSection === section.id ? 'bg-primary-50 text-primary-700 shadow-sm ring-1 ring-primary-100' : 'text-gray-600 hover:bg-gray-50 hover:text-charcoal-800'}`} data-id="element-7062">
                    <section.icon className={`w-4 h-4 flex-shrink-0 transition-colors ${activeSection === section.id ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-600'}`} data-id="element-7063" />
                    <span className="truncate" data-id="element-7064">{section.title}</span>
                    {activeSection === section.id && <motion.div layoutId="activeIndicator" className="ml-auto" data-id="element-7065">
                        <ChevronRight className="w-4 h-4 text-primary-400" data-id="element-7066" />
                      </motion.div>}
                  </button>)}
              </nav>

              <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-7067">
                <div className="bg-blue-50/50 rounded-2xl p-5 border border-blue-100" data-id="element-7068">
                  <h4 className="font-bold text-blue-900 text-sm mb-2 flex items-center gap-2" data-id="element-7069">
                    <HelpCircle className="w-4 h-4" data-id="element-7070" />
                    ¿Dudas legales?
                  </h4>
                  <p className="text-xs text-blue-800/80 mb-3 leading-relaxed" data-id="element-7071">
                    Nuestro equipo legal está disponible para aclarar cualquier
                    punto.
                  </p>
                  <a href="mailto:legal@petiora.co" className="text-xs font-bold text-blue-700 hover:underline flex items-center gap-1" data-id="element-7072">
                    Contactar soporte legal <ArrowRight className="w-3 h-3" data-id="element-7073" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 w-full min-w-0" data-id="element-7074">
            <div className="bg-white rounded-[2.5rem] shadow-xl shadow-gray-200/50 border border-gray-100 overflow-hidden" data-id="element-7075">
              <div className="p-8 sm:p-12 lg:p-16 space-y-20" data-id="element-7076">
                {sections.map((section, idx) => <section key={section.id} id={section.id} className="scroll-mt-32 relative" data-id="element-7077">
                    <div className="flex items-center gap-4 mb-8" data-id="element-7078">
                      <div className="w-14 h-14 rounded-2xl bg-primary-50 flex items-center justify-center text-primary-600 flex-shrink-0 shadow-sm border border-primary-100" data-id="element-7079">
                        <section.icon className="w-7 h-7" data-id="element-7080" />
                      </div>
                      <h2 className="text-2xl sm:text-3xl font-bold text-charcoal-800 font-serif" data-id="element-7081">
                        {section.title}
                      </h2>
                    </div>

                    <div className="pl-0 sm:pl-[4.5rem] text-gray-600 leading-relaxed text-lg content-section" data-id="element-7082">
                      {section.content}
                    </div>

                    {idx < sections.length - 1 && <div className="h-px bg-gradient-to-r from-transparent via-gray-100 to-transparent mt-20 ml-0 sm:ml-[4.5rem]" data-id="element-7083" />}
                  </section>)}
              </div>
            </div>

            {/* Footer Note */}
            <div className="mt-12 text-center text-gray-500 text-sm max-w-2xl mx-auto" data-id="element-7084">
              <p data-id="element-7085">
                Estas condiciones han sido redactadas de conformidad con la
                normativa española y europea vigente. Petiora S.L. se reserva el
                derecho de emprender acciones legales en caso de incumplimiento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>;
}